export default {
  path: 'oaTemplateManage',
  name: 'oaTemplateManage',
  component: () => import('@/pages/oa/tpl/manageTable'),
  meta: { title: 'OA审批管理' }

}
